import React, {useEffect, useState} from "react";
import {Tabs} from "components/common";
import {items} from "./config";
import {useAppDispatch, useAppSelector} from "redux/hooks";
import {setButtonsHeader, setSiderKey} from "redux/reducer/common";
const Authorization: React.FC = () => {
  const dispatch = useAppDispatch();
  useEffect(() => {
    dispatch(setButtonsHeader([]));
    dispatch(setSiderKey("phanQuyen"));
  }, []);
  const activeKey = useAppSelector(state => state.common.activeTab);
  return (
    <div className="authorization page">
      <div className="main">
        <Tabs items={items} activeKey={activeKey} />
      </div>
    </div>
  );
};
export default Authorization;
